import React from "react";
import { UserGameplayOutcome } from "@nestcoinco/hyper-api-gateway-api-client";

import "./GameStreak.scss";

interface GameStreakProps {
  outcomes?: UserGameplayOutcome[];
}

const OUTCOME_CONFIG: Record<
  UserGameplayOutcome,
  { label: string; className: string }
> = {
  [UserGameplayOutcome.W]: { label: "W", className: "win" },
  [UserGameplayOutcome.L]: { label: "L", className: "loss" },
  [UserGameplayOutcome.T]: { label: "D", className: "draw" },
};

function GameStreak({ outcomes }: GameStreakProps) {
  if (!outcomes?.length) return null;

  return (
    <div className="game-streak">
      {[...outcomes].reverse().map((outcome, index) => {
        const { label, className } = OUTCOME_CONFIG[outcome];
        return (
          <span key={`${outcome}-${index}`} className={`badge ${className}`}>
            {label}
          </span>
        );
      })}
    </div>
  );
}

export default GameStreak;
